import { ViewDensity, ViewType } from "@common/types/views/views";
import { HistoryView, HistoryColumn } from "./historyView";

export const defaultHistoryView: HistoryView = {
    type: ViewType.HISTORY,
    columns: [
        { id: HistoryColumn.DATE },
        { id: HistoryColumn.UPDATED_BY },
        { id: HistoryColumn.ACTION },
        {
            id: HistoryColumn.ENTITY,
            options: {
                pin: "right",
            },
        },
        {
            id: HistoryColumn.ACTIONS,
            options: {
                pin: "right",
            },
        },
    ],
    filters: {},
    options: {
        selection: true,
        density: ViewDensity.MD,
    },
};
